import React from 'react'

export function LoadingSpinner() {

    return (
        <div className="ace-cal-loading space-top-xl">
            <div className="sfjazz-loading-container">
                <div className="sfjazz-loading-text">LOADING...</div>
            </div>
        </div>
    );
}